import React from "react";

export const overrides = {
  h1: {
    component: "h1" as React.ElementType,
    props: {
      className:
        "text-[1.35rem] 2xl:text-[1.5rem] font-bold mb-5 pb-2 border-b-2 ",
    },
  },
  h2: {
    component: "h2" as React.ElementType,
    props: {
      className: "text-[1.125rem] 2xl:text-[1.25rem] font-bold mb-5 ",
    },
  },
  h3: {
    component: "h3" as React.ElementType,
    props: {
      className: "text-[1.0125rem] 2xl:text-[1.125rem] font-bold mb-5 ",
    },
  },
  h4: {
    component: "h4" as React.ElementType,
    props: {
      className: "text-[1.0125rem] 2xl:text-[1.125rem] font-semibold mb-5 ",
    },
  },
  h5: {
    component: "h5" as React.ElementType,
    props: {
      className: "text-[0.9rem] 2xl:text-[1rem] font-semibold mb-5 ",
    },
  },
  h6: {
    component: "h6" as React.ElementType,
    props: {
      className: "text-[0.7875rem] 2xl:text-[0.875rem] font-semibold mb-5 ",
    },
  },
  p: {
    component: "p" as React.ElementType,
    props: {
      className: "text-[0.875rem] 2xl:text-[1rem] leading-relaxed mb-5 ",
    },
  },
  ul: {
    component: "ul" as React.ElementType,
    props: {
      className:
        "list-disc pl-5 text-[0.875rem] 2xl:text-[1rem] mb-5 space-y-1",
    },
  },
  ol: {
    component: "ol" as React.ElementType,
    props: {
      className:
        "list-decimal pl-5 text-[0.875rem] 2xl:text-[1rem] mb-5 space-y-1",
    },
  },
  li: {
    component: "li" as React.ElementType,
    props: {
      className: "mb-1 ",
    },
  },
  table: {
    component: "table" as React.ElementType,
    props: {
      className:
        "table-auto border-collapse text-[0.7875rem] 2xl:text-[0.875rem] mb-5 block overflow-x-auto w-full",
    },
  },
  thead: {
    component: "thead" as React.ElementType,
    props: {
      className: "font-semibold",
    },
  },
  th: {
    component: "th" as React.ElementType,
    props: {
      className: "border border-gray-300 px-3 py-2 text-left font-medium",
    },
  },
  td: {
    component: "td" as React.ElementType,
    props: {
      className: "border border-gray-300 px-3 py-2",
    },
  },
  strong: {
    component: "strong" as React.ElementType,
    props: {
      className: "font-semibold",
    },
  },
  em: {
    component: "em" as React.ElementType,
    props: {
      className: "italic",
    },
  },
  blockquote: {
    component: "blockquote" as React.ElementType,
    props: {
      className: "border-l-4 border-blue-300 pl-4 italic mb-5",
    },
  },
  code: {
    component: "code" as React.ElementType,
    props: {
      className: "rounded px-1 font-mono text-[0.7875rem] 2xl:text-[0.875rem]",
    },
  },
  pre: {
    component: "pre" as React.ElementType,
    props: {
      className:
        "p-3 rounded overflow-x-auto text-[0.875rem] 2xl:text-[1rem] mb-5",
    },
  },
};
